import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — decor: a wall-mounted lit menu panel for a fast-food
// counter, authored at its true mounting height (centred around y = 1.9),
// flat against the wall at z = 0, facing +Z. Three lighter menu cards sit
// proud of the dark panel.
const PANEL = "#2e2e30";
const CARD = "#e8e4dc";

export const menuBoard = defineModel({
  id: "menu-board",
  batchId: "modern",
  name: "Menu board",
  tags: ["modern", "interior", "decor", "restaurant", "sign", "wall-mounted"],
  summary: "A wall-mounted lit menu panel with three menu cards.",
  tiles: { w: 1, h: 1 },
  footprint: 0.8,
  parts(): Part[] {
    return [
      // dark panel against the wall
      { geometry: new THREE.BoxGeometry(1.0, 0.5, 0.05), color: PANEL, position: [0, 1.9, 0.025] },
      // three menu cards proud of the panel
      { geometry: new THREE.BoxGeometry(0.26, 0.38, 0.015), color: CARD, position: [-0.33, 1.9, 0.058] },
      { geometry: new THREE.BoxGeometry(0.26, 0.38, 0.015), color: CARD, position: [0, 1.9, 0.058] },
      { geometry: new THREE.BoxGeometry(0.26, 0.38, 0.015), color: CARD, position: [0.33, 1.9, 0.058] },
    ];
  },
  animations: [],
});
